import { createSelector } from '@app/utils/createSelector'

import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'
import type { SliceState } from '@app/packages/thunkSelector/withCheckedSliceState'
import { withCheckedSliceState } from '@app/packages/thunkSelector/withCheckedSliceState'

import { callInternalApi } from '@app/store/actions/api'
import { createReduxSlice } from '@app/store/redux_slice'

export type SitterFaqLink = {
  title: string
  url: string
}

const sitterFaqMessageSlice = createReduxSlice<SliceState<SitterFaqLink[]>>('sitter_faq_message')

export const sitterFaqMessageLinksSelector = createSelector([sitterFaqMessageSlice.selector], slice =>
  createLoadable(c =>
    withCheckedSliceState(c, {
      sliceState: slice,
      slice: sitterFaqMessageSlice,
      load: async dispatch => {
        const { getSitterFaqMessages } = await import('@app/packages/internalApi/actions/sitter_faq_messages')
        const response = await dispatch(callInternalApi(getSitterFaqMessages()))
        return response.data.map(item => ({ title: item.attributes.title, url: item.attributes.url }))
      },
    })
  )
)
